/**
 * Class to represent a domain type object, that enables conversion between code and name
 */
export default class Domain {
    /**
     * Constructor to instantiate a domain class
     * @param {Array} arr Required. An array of objects that contains only two properties, one serving as the code, and the other as name or description
     * @param {Object} conf optional. Configuration to show which property of the object in arr is the code, which is the name
     */
    constructor(arr, conf) {
        let domain = {};

        const propCode = (conf && conf.code) || 'code',
            propName = (conf && conf.name) || 'name';

        if (!Array.isArray(arr)) {
            console.error('Failed to instantiate a Domain class: The first parameter to the constructor should be an array of objects');
        }

        if (arr.length === 0) {
            console.error('Failed to instantiate a Domain class: the first parameter is an empty array');
        }

        const firstObj = arr[0];
        if (Object.keys(firstObj).length > 2 || !firstObj.hasOwnProperty(propCode) || !firstObj.hasOwnProperty(propName)) {
            console.error('Failed to instantiate a Domain class: invalid input parameters');
        }

        arr.forEach(elem => {
            domain[elem[propCode]] = elem[propName];
        });

        this.domain = Object.assign({}, domain);
    }

    toName(code) {
        return this.domain[code];
    }

    toCode(name) {
        Object.keys(this.domain).forEach(code => {
            if (this.domain[code] === name) {
                return code;
            }
        });

        return null;
    }
}